
























import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { PageName, pageNameMap, redirectTo, router } from '@/router'

export default defineClassComponent(
  () =>
    class {
      loading = computed(() => false)

      tabs = ref<
        Array<{
          icon: string
          activeIcon: string
          label: string
          pageName: PageName
          isActive: boolean
        }>
      >([
        {
          icon: require('./images/tabs/首页.png'),
          activeIcon: require('./images/tabs/首页_选中.png'),
          label: '首页',
          pageName: 'DkyIndex',
          isActive: router.currentRoute.name === pageNameMap.DkyIndex,
        },
        {
          icon: require('./images/tabs/购物车.png'),
          activeIcon: require('./images/tabs/购物车_选中.png'),
          label: '购物车',
          pageName: 'DkyCart',
          isActive: router.currentRoute.name === pageNameMap.DkyCart,
        },
        {
          icon: require('./images/tabs/我的.png'),
          activeIcon: require('./images/tabs/我的_选中.png'),
          label: '我的',
          pageName: 'DkyUser',
          isActive: router.currentRoute.name === pageNameMap.DkyUser,
        },
      ])

      handleTabClick = (index: number) => {
        redirectTo(this.tabs.value[index].pageName)
      }
    },
)
